import { Component } from '@angular/core';
import { PlayerNotifyComponent } from '@splixer/player-ui';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'knkx-root-page',
  templateUrl: 'root.page.html',
  imports: [PlayerNotifyComponent, RouterOutlet],
  standalone: true,
})
export class KnkxRootPage {
  constructor() {
    console.info('Build 2026.05.20-1');
  }
}
